
const BottomNav = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'home', icon: 'ri-home-line', activeIcon: 'ri-home-fill', label: 'Home' },
    { id: 'plans', icon: 'ri-vip-crown-line', activeIcon: 'ri-vip-crown-fill', label: 'Plans' },
    { id: 'wallet', icon: 'ri-wallet-line', activeIcon: 'ri-wallet-fill', label: 'Wallet' },
    // { id: 'rewards', icon: 'ri-gift-line', activeIcon: 'ri-gift-fill', label: 'Rewards' },
    { id: 'referral', icon: 'ri-group-fill', activeIcon: 'ri-group-fill', label: 'referral' },
    { id: 'profile', icon: 'ri-user-line', activeIcon: 'ri-user-fill', label: 'Profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50">
      <div className="grid grid-cols-5 h-16">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center justify-center space-y-1 transition-colors ${
              activeTab === tab.id
                ? 'text-orange-500'
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`${activeTab === tab.id ? tab.activeIcon : tab.icon} text-lg`}></i>
            </div>
            <span className="text-xs font-medium">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
